import { Flex, Text, Collapse, Box } from "@chakra-ui/react";
import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { BaseInput } from "../BaseInput";

interface FinancialInfoBlockProps {
  // Max ставки продажи
  valueGeneral: string;
  valueMoscow: string;
  valueRegion: string;
  onChangeGeneral: (value: string) => void;
  onChangeMoscow: (value: string) => void;
  onChangeRegion: (value: string) => void;
  // Зарплаты на руки в месяц
  valueSalaryTk: string;
  valueSalaryIp: string;
  valueSalaryGph: string;
  onChangeSalaryTk: (value: string) => void;
  onChangeSalaryIp: (value: string) => void;
  onChangeSalaryGph: (value: string) => void;
  requiredField?: boolean;
}

export const FinancialInfoBlock = ({
  valueGeneral,
  valueMoscow,
  valueRegion,
  onChangeGeneral,
  onChangeMoscow,
  onChangeRegion,
  valueSalaryTk,
  valueSalaryIp,
  valueSalaryGph,
  onChangeSalaryTk,
  onChangeSalaryIp,
  onChangeSalaryGph,
  requiredField = false,
}: FinancialInfoBlockProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => setIsOpen((prev) => !prev);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <Box borderWidth="1px" borderColor="#3B82F6" borderRadius="md" bg="gray.50">
      <Flex
        as="button"
        type="button"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        px="3"
        py="2"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls="financial-info-collapse"
        bg="#3B82F6"
        color="white"
      >
        <Text fontSize="md" fontWeight="semibold" color="white">
          Финансовая информация
          {requiredField && (
            <Text as="span" color="red.500" ml="1">
              *
            </Text>
          )}
        </Text>
        <Flex alignItems="center" gap="8px">
          {!isOpen && (
            <Text fontSize="sm" color="white" fontWeight="bold">
              Развернуть
            </Text>
          )}
          {isOpen ? <ChevronUpIcon color="white" /> : <ChevronDownIcon color="white" />}
        </Flex>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Box p="12px">
          {/* Max ставки продажи */}
          <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb="8px">
            Max ставки продажи
          </Text>
          <Flex flexDirection="row" gap="24px" mb="16px" alignItems="flex-start">
            <BaseInput
              fieldTitle="Общая"
              value={valueGeneral}
              onChange={(e) => onChangeGeneral((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
            <BaseInput
              fieldTitle="МСК и МО"
              value={valueMoscow}
              onChange={(e) => onChangeMoscow((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
            <BaseInput
              fieldTitle="Регион"
              value={valueRegion}
              onChange={(e) => onChangeRegion((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
          </Flex>

          {/* Зарплаты на руки в месяц */}
          <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb="8px">
            Зарплаты на руки в месяц
          </Text>
          <Flex flexDirection="row" gap="24px" mb="16px" alignItems="flex-start">
            <BaseInput
              fieldTitle="ТК"
              value={valueSalaryTk}
              onChange={(e) => onChangeSalaryTk((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
            <BaseInput
              fieldTitle="ИП"
              value={valueSalaryIp}
              onChange={(e) => onChangeSalaryIp((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
            <BaseInput
              fieldTitle="ГПХ"
              value={valueSalaryGph}
              onChange={(e) => onChangeSalaryGph((e.target as HTMLInputElement).value)}
              containerStyles={{ width: "33%" }}
            />
          </Flex>
        </Box>
      </Collapse>
      {requiredField && (
        <Text fontSize="xs" color="red.500" mt="2" px="3" pb="2">
          Обязательное поле
        </Text>
      )}
    </Box>
  );
};
